import {
  loginRequest,
  loginError,
  loginSuccess,
  logoutSuccess,
  headingData,
  permissionData,
  setAccessDenied,
} from "./reducer";
import { ROLE, PERMISSION, USER_ID, TOKEN } from "constants/enums";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import callApi from "Common/utils/apiCaller";

export const ssoLoginUser =
  (
    idToken: string,
    history: any
  ): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    // Clear previous state BEFORE attempting login
    dispatch(loginRequest());

    try {
      let res = await callApi("v1/admin/login", "post", {
        admin: { id_token: idToken },
      });

      // Check if response indicates success
      if (res && res.status === "Success") {
        localStorage.setItem(TOKEN, JSON.stringify(res.data.token));
        localStorage.setItem(USER_ID, JSON.stringify(res.data.admin?._id));

        dispatch(loginSuccess(res.data.admin?._id));
        dispatch(headingData(res.data.admin?._id));

        if (
          res.data.admin?.role &&
          JSON.parse(window.localStorage.getItem(TOKEN))
        ) {
          try {
            let response = await callApi(
              `v1/admin/${res.data.admin?._id}/roles/${res.data.admin?.role}/fetch-permissions`,
              "post"
            );

            if (response.status === "Success") {
              localStorage.setItem(
                PERMISSION,
                JSON.stringify(response.data.role)
              );
              localStorage.setItem(ROLE, JSON.stringify(response.data.role.name));
              dispatch(permissionData(response.data.role));
            }
          } catch (permissionError: any) {
            // Log permission fetch error but don't block login
            console.error("Failed to fetch permissions:", permissionError);
          }
        }

        // Navigate to home page
        history("/");
      } else {
        // Handle non-success response status
        const errorMessage =
          res?.data?.message ||
          res?.message ||
          "Unable to sign in with Microsoft. Please try again.";

        dispatch(loginError(errorMessage));
      }
    } catch (error: any) {
      // Handle all types of errors from callApi
      console.error("SSO login error:", error);

      const code = error?.data?.data?.code || error?.data?.code;

      if (code === "ADMIN_NOT_FOUND") {
        dispatch(setAccessDenied(true));
        return;
      }

      // Extract error message from the structured error object
      const errorMessage =
        error?.message ||
        error?.data?.message ||
        error?.data?.data?.message ||
        "Unable to sign in with Microsoft. Please try again.";

      dispatch(loginError(errorMessage));
    }
  };

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    // Tell the API first so it ends this session; an expired or already-revoked
    // token must not stop the user from signing out locally.
    try {
      await callApi("v1/admin/logout", "post");
    } catch {
      // ignore, local sign-out below still happens
    }

    localStorage.removeItem(TOKEN);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(PERMISSION);
    localStorage.removeItem(ROLE);
    window.sessionStorage.setItem("logged_out", "1");
    dispatch(logoutSuccess(true));
  } catch (error: any) {
    const errorMessage = error?.message || "Failed to logout";
    dispatch(loginError(errorMessage));
  }
};
